export function SmartleadIcon() {
  return <img src="/smartlead.svg" alt="Smartlead" className="h-6 w-6" />;
}
